import { Tab, Tabs } from '@material-ui/core'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { PageTabsBar } from 'app/components/generic/PageLayout'
import { navigationPaths } from 'app/config'

import ExploreSession from './ExploreSession/ExploreSession'
import MakeUpSession from './MakeUpSession/ShowMakeUpSession/MakeUpSession'
import ToddlerClubSession from './ToddlerClubSession/ToddlerClubSession'
import TrialSessions from './TrialSessions/TrialSessions'

const TAB_BY_PATH = {
  [navigationPaths.trialsessions]: 'trial',
  [navigationPaths.exploreSession]: 'explore',
  [navigationPaths.toddlerClubSession]: 'toddlerClub',
  [navigationPaths.makeUpSession]: 'makeup'
}

const PATH_BY_TAB = {
  trial: navigationPaths.trialsessions,
  explore: navigationPaths.exploreSession,
  toddlerClub: navigationPaths.toddlerClubSession,
  makeup: navigationPaths.makeUpSession
}

const TAB_COMPONENT = {
  trial: TrialSessions,
  explore: ExploreSession,
  toddlerClub: ToddlerClubSession,
  makeup: MakeUpSession
}

const Sessions = () => {
  const history = useHistory()
  const { pathname } = useLocation()
  const currentTab = TAB_BY_PATH[pathname] || 'trial'

  const handleTabChange = (_, value) => {
    if (value !== currentTab) history.push(PATH_BY_TAB[value])
  }

  const TabComponent = TAB_COMPONENT[currentTab]

  return (
    <>
      <PageTabsBar>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
        >
          <Tab label="Trial & Drop-In" value="trial" />
          <Tab label="Explore" value="explore" />
          <Tab label="Toddler Club" value="toddlerClub" />
          <Tab label="Make-Up" value="makeup" />
        </Tabs>
      </PageTabsBar>
      <TabComponent />
    </>
  )
}

export default Sessions
